module.exports = __webpack_public_path__ + "img/compareImgRight.84e31c74.jpg";